export const Summary = ({ f, w }) => {
  const vehicle = [f.year, f.make, f.model].filter(Boolean).join(" ");
  const when = f.urgency === "Schedule a time" ? [f.schedule_date, w.times[f.schedule_time]].filter(Boolean).join(" · ") : w.when[f.urgency];
  const rows = [
    [w.labels.service, w.services[f.service]],
    [w.labels.vehicle, [w.vehicles[f.vehicle_type], vehicle].filter(Boolean).join(" — ")],
    [w.labels.key, w.keys[f.key_status]],
    [w.labels.place, [w.places[f.place], f.location].filter(Boolean).join(" — ")],
    [w.labels.when, when],
    [w.labels.contact, [f.name, f.phone, f.email].filter(Boolean).join(" · ")],
    [w.photoT, f.key_photos?.length ? `${f.key_photos.length} ✓` : ""],
  ].filter(([, v]) => v);
  if (!rows.length) return null;
  return (
    <div data-testid="wizard-summary" className="border border-white/15 bg-ink p-5">
      <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-brand2">{w.summary}</div>
      <dl className="mt-3 divide-y divide-white/10">
        {rows.map(([k, v]) => (
          <div key={k} className="grid grid-cols-3 gap-3 py-2.5 text-sm">
            <dt className="text-zinc-400">{k}</dt>
            <dd className="col-span-2 font-semibold text-bone">{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
